import { GameConfigDTO } from '@envclient/envcore';
import { CcsonFamilyTypeDTO, CcsonGameTypeDTO } from '../types/ccson_env';
import ccsonGameConfigJson from '@envclient/envengine/src/config/ccson/ccson_config.json';
import koenigsburgGameConfigJson from '@envclient/envengine/src/config/koenigsburg/koenigsburg_config.json';
import chessGameConfigJson from '@envclient/envengine/src/config/chess/chess_config.json';
import { KGameTypeDTO } from '@envclient/envengine/src/envs/koenigsburg/kGameConfigLoader';

// create union types - Java export doesnt make the link between them
export type TileBasedGameType = CcsonGameTypeDTO | KGameTypeDTO | 'chess';
export type TileBasedGameFamilyType = CcsonFamilyTypeDTO | 'koenigsburg' | 'chess';

export const ccsonGameConfigs = ccsonGameConfigJson as GameConfigDTO[];
export const koenigsburgGameConfigs = koenigsburgGameConfigJson as GameConfigDTO[];
export const chessGameConfigs = chessGameConfigJson as GameConfigDTO[];
